import { get, post } from '@/fn/ajax'
import { ListType, ItemType, ItemData } from '@/util/types'
import { mockData, imageList, title20 } from '@/util/mock'
import { delay } from '@/fn/timer'
import { MapType } from '@/util/types'
import shortid from 'shortid'

const actionsMap: MapType<any> = {
  // 云端课程
  10: {
    hideEdit: true,
    hideAdd: true,
  },

  // 我的课程
  11: {
    hideAdd: true
  },

  // 云端资源
  20: {
    hidePlay: true,
    hideEdit: true,
  },

  // 我的资源
  21: {
    hidePlay: true,
    hideEdit: true,
  }
}

const dealList = (list: any[] | null, type: ListType, mapItem?: (item: any) => any) => {
  const itemType = Math.floor(type / 10) as ItemType
  const actions = actionsMap[type]
  const result = (list || []).map(item => {
    return {
      _id: shortid.generate(), // 作为组件key，以防后端传回的数据中有id重复的
      type: itemType,
      ...actions,
      ...(mapItem ? mapItem(item) : item),
    } as ItemData
  })
  return result
}

const mockList = async (type: ListType, query: any) => {
  await delay(200)

  const {
    data: {
      list,
      total
    }
  } = mockData({
    'list|15': [
      {
        id: '@id',
        'cover|1': imageList,
        title: title20,
        'count|0-12': 8,
      }
    ],
    'total|1': [88, 188],
  })

  return {
    list: dealList(list, type),
    total
  }
}

/**
 * 获取云端课程列表
 * @param query 查询
 */
const getCloudCourseList = async (query: any) => {
  // return mockList(ListType.cloudCourse, query)
  const { data } = await get('/api/lesson/alist', query)

  const list = dealList(data.list, ListType.cloudCourse, item => {
    return {
      id: item.id,
      cover: item.banner,
      title: item.title,
      count: item.res_cnt,
      res_list: (item.res_list as any[] || []).map(({ rid, title, res_type, use_explain }) => ({ id: rid, title, res_type, use_explain })),
    }
  })

  return {
    list,
    total: data.total,
  }
}

/**
 * 获取我的课程列表
 * @param query 查询
 */
const getMyCourseList = async (query: any) => {
  // return mockList(ListType.myCourse, query)
  const { data } = await get('/api/course/getlist', query)

  const list = dealList(data.list, ListType.myCourse, item => {
    return {
      id: item.id,
      cover: item.resource_list.slice(0, 4).map((el: any) => ({ ...el, _id: shortid.generate() })),
      title: item.course_title,
      count: item.resource_list.length,
      res_list: (item.resource_list as any[] || []).map(({ id, title, res_type, use_explain }) => ({ id, title, res_type, use_explain }))
    }
  })

  return {
    list,
    total: data.total,
  }
}

/**
 * 获取我的资源列表
 * @param query 查询
 */
const getMyResourceList = async (query: any) => {
  return mockList(ListType.myResource, query)
}

/**
 * 获取云端资源列表
 * @param query 查询
 */
const getCloudResourceList = async (query: any) => {
  const { data } = await get('/api/res/alist', query)

  const list = dealList(data.list.list, ListType.cloudResource, item => {
    return {
      id: item.id,
      cover: item.cover,
      title: item.title,
      count: 1,
      res_type: item.res_type,
      use_explain: item.use_explain
    }
  })

  return {
    list,
    total: data.total,
  }
}

/**
 * 获取云端资源列表
 * @param query 查询
 */
const getOwnerResourceList = async (query: any) => {
  query.channel = 2
  const { data } = await get('/api/res/alist', query)

  const list = dealList(data.list.list, ListType.cloudResource, item => {
    return {
      id: item.id,
      cover: item.cover,
      title: item.title,
      count: 1,
      res_type: item.res_type,
      use_explain: item.use_explain
    }
  })

  return {
    list,
    total: data.total,
  }
}
const listMap: MapType<(query: any) => Promise<{ list: ItemData[], total: number }>> = {
  10: getCloudCourseList,
  11: getMyCourseList,
  20: getCloudResourceList,
  21: getOwnerResourceList,
}

export async function getList(type: ListType, query: any) {
  const result = await listMap[type](query)
  return result
}

export async function delCourse(query: object) {
  const res = await post('/api/course/delete_json', query)
  return res
}
